// extracted by mini-css-extract-plugin
export default {"container":"U2-z"};